module.exports = __webpack_public_path__ + "dist/media/logo--sk.8f771c25.svg";